var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 72,
    viewBox: "0 0 92 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7999 35.9C85.7999 40.8 81.5999 44.8 77.0999 46.4C72.5999 48 67.5999 47.9 62.7999 48.4C57.9999 48.9 52.3999 53.3 48.9999 56.8C46.7999 59.1 45.6999 62.2 44.0999 65C42.4999 67.8 40.2999 70.5 37.1999 71.2C33.7999 71.8999 30.2999 69.7 28.2999 66.9C26.2999 64 25.3999 60.5 24.3999 57.1C23.3999 53.7 22.8999 47 20.4999 44.4C18.3999 42.2 15.5999 40.8 12.8999 39.4C10.1999 38 7.39995 36.5 5.69995 34C3.89995 31.5 3.39995 27.9 5.29995 25.5C7.69995 22.5 12.0999 22.9 15.8999 22.6C22.9999 22 29.5999 17.7 33.1999 11.6C34.4999 9.29995 35.3999 6.79995 36.8999 4.49995C38.3999 2.29995 40.4999 0.299953 43.1999 -4.69312e-05C46.8999 -0.400047 49.9999 2.59995 52.5999 5.29995C57.4999 10.5 62.1999 17.1 68.5999 20.5C74.8999 23.9 85.7999 26.8 85.7999 35.9Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7 5.10006C89.8 5.50006 89.5 5.90006 89.2 6.00006L88.2 6.20006L88.4 7.20006C88.5 7.60006 88.2 8.00006 87.8 8.10006C87.4 8.20006 87 7.90006 87 7.50006L86.8 6.50006L85.8 6.70006C85.4 6.80006 85 6.50006 84.9 6.10006C84.8 5.70006 85.1 5.30006 85.4 5.20006L86.4 5.00006L86.2 4.00006C86.1 3.60006 86.4 3.20006 86.7 3.10006C87.1 3.00006 87.5 3.30006 87.6 3.60006L87.8 4.60006L88.8 4.40006C89.2 4.40006 89.6 4.70006 89.7 5.10006Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89996 51.3C5.99996 51.7 5.69996 52.1 5.39996 52.2L4.39996 52.4L4.59996 53.4C4.69996 53.8 4.39996 54.2 3.99996 54.3C3.59996 54.4 3.19996 54.1 3.09996 53.8L2.89996 52.8L1.89996 53C1.49996 53 1.09996 52.8 0.999962 52.4C0.899962 52 1.19996 51.6 1.49996 51.5L2.49996 51.3L2.29996 50.3C2.19996 49.9 2.49996 49.5 2.79996 49.4C3.19996 49.3 3.59996 49.6 3.69996 49.9L3.99996 51L4.99996 50.8C5.39996 50.6 5.79996 50.9 5.89996 51.3Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 6.40002C8.89995 6.80002 8.49995 7.00002 8.09995 6.90002L7.09995 6.70002L6.89995 7.70002C6.79995 8.10002 6.39995 8.40002 5.99995 8.30002C5.59995 8.20002 5.39995 7.80002 5.49995 7.40002L5.69995 6.40002L4.69995 6.20002C4.29995 6.10002 3.99995 5.70002 4.09995 5.30002C4.19995 4.90002 4.59995 4.70002 4.99995 4.70002L5.99995 5.00002L6.19995 4.00002C6.29995 3.60002 6.69995 3.40002 7.09995 3.40002C7.49995 3.50002 7.69995 3.90002 7.69995 4.30002L7.49995 5.30002L8.49995 5.50002C8.79995 5.60002 9.09995 6.00002 8.99995 6.40002Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9 68.1C57.8 68.5 57.4 68.7 57 68.7L56 68.5L55.8 69.5C55.7 69.9 55.3 70.1 54.9 70.1C54.5 70 54.3 69.6 54.3 69.2L54.5 68.2L53.5 68C53.1 67.9 52.9 67.5 52.9 67.1C53 66.7 53.4 66.5 53.8 66.5L54.8 66.7L55 65.7C55.1 65.3 55.5 65.1 55.9 65.1C56.3 65.2 56.5 65.6 56.5 66L56.3 67L57.3 67.2C57.8 67.3 58 67.7 57.9 68.1Z",
    fill: "#E8F0FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 62.3H91",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 62.3H81.1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 62.3H16.7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 19.7H8.30005V62.2999H73.8V19.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 19.7H8.30005V62.2999H12.2V19.7Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 19.7V13C8.30005 10.3 10.5 8.09998 13.2 8.09998H69C71.7001 8.09998 73.9 10.3 73.9 13V19.7H8.30005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 13V19.7H12.8V13C12.8 10.3 15 8.09998 17.7 8.09998H13.2C10.5 8.09998 8.30005 10.3 8.30005 13Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 22.9V54.4L72.6 52.8C72.5 52.8 72.4 52.8 72.3 52.8C72.1 52.8 71.9 52.8 71.8 52.8C70.8 52.7 70 52.2 69.4 51.4L68.1 49.6C67.6 49.6 67.1 49.7 66.7 49.7C62.2 49.7 57.8 47.5 55.1 43.9C52.8 40.8 51.9 37 52.5 33.3C53.1 29.5 55.1 26.2 58.2 23.9C60.7 22.1 63.6 21.1 66.7 21.1C69.2 21 71.7 21.7 73.8 22.9Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 62.2999H8.30005V19.7H73.8V62.2999H25.4",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 19.7V13C8.30005 10.3 10.5 8.09998 13.2 8.09998H69C71.7 8.09998 73.9 10.3 73.9 13V19.7H8.30005Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 13.8999C18.6 15.3999 17.4 16.4999 16 16.4999C14.5 16.4999 13.4 15.2999 13.4 13.8999C13.4 12.3999 14.6 11.2999 16 11.2999C17.4 11.2999 18.6 12.4999 18.6 13.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 13.8999C18.6 15.2999 17.4 16.4999 16 16.4999C15.6 16.4999 15.3 16.3999 15 16.2999C16 15.8999 16.6 14.9999 16.6 13.8999C16.6 12.7999 15.9 11.8999 15 11.4999C15.3 11.3999 15.6 11.2999 16 11.2999C17.4 11.2999 18.6 12.4999 18.6 13.8999Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 13.8999C27.6 15.3999 26.4 16.4999 25 16.4999C23.5 16.4999 22.4 15.2999 22.4 13.8999C22.4 12.3999 23.6 11.2999 25 11.2999C26.4 11.2999 27.6 12.4999 27.6 13.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 13.9C27.6 15.3 26.4 16.5 25 16.5C24.7 16.5 24.3 16.4 24 16.3C25 15.9 25.7 15 25.7 13.9C25.7 12.8 25 11.8 24 11.4C24.3 11.3 24.6 11.2 25 11.2C26.4 11.3 27.6 12.5 27.6 13.9Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 13.8999C36.6 15.3999 35.4 16.4999 34 16.4999C32.5 16.4999 31.4 15.2999 31.4 13.8999C31.4 12.3999 32.6 11.2999 34 11.2999C35.4 11.2999 36.6 12.4999 36.6 13.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 13.9C36.6001 15.3 35.4001 16.5 34.0001 16.5C33.7001 16.5 33.4001 16.4 33.1001 16.3C34.1001 15.9 34.8001 15 34.8001 13.8C34.8001 12.7 34.1001 11.7 33.1001 11.3C33.4001 11.2 33.7001 11.1 34.0001 11.1C35.4001 11.3 36.6001 12.5 36.6001 13.9Z",
    fill: "#FFF0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 13.8999C18.6 15.3999 17.4 16.4999 16 16.4999C14.5 16.4999 13.4 15.2999 13.4 13.8999C13.4 12.3999 14.6 11.2999 16 11.2999C17.4 11.2999 18.6 12.4999 18.6 13.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6 13.8999C27.6 15.3999 26.4 16.4999 25 16.4999C23.5 16.4999 22.4 15.2999 22.4 13.8999C22.4 12.3999 23.6 11.2999 25 11.2999C26.4 11.2999 27.6 12.4999 27.6 13.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 13.8999C36.6 15.3999 35.4 16.4999 34 16.4999C32.5 16.4999 31.4 15.2999 31.4 13.8999C31.4 12.3999 32.6 11.2999 34 11.2999C35.4 11.2999 36.6 12.4999 36.6 13.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8001 13.9H41.3",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1 44.9999C43.3 42.7999 43.6 37.3999 43.8 34.6999C43.9 33.0999 42.7 31.7999 41.1 31.7999C39.5 31.7999 38.2 33.1999 38.4 34.6999C38.6 37.3999 38.9 42.6999 39.1 44.9999C39.2 45.9999 40.1 46.7999 41.1 46.7999C42.1 46.8999 43 46.0999 43.1 44.9999Z",
    fill: "#FF681D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7999 50.5C42.7999 51.5 42 52.2999 41 52.2999C40 52.2999 39.2 51.5 39.2 50.5C39.2 49.5 40 48.7 41 48.7C42 48.8 42.7999 49.6 42.7999 50.5Z",
    fill: "#FF681D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 71.4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3f8e986f.svg";
export { ForwardRef as ReactComponent };